import * as React from 'react';

function Support() {
	return (
		<>
			<div id="Dashboard" className="tabcontent">
				<p className="pheadline">Support</p>
				<p>Support is the capital city of England.</p>
			</div>
		</>
	);
}

export default Support;
